import CheckIcon from "@mui/icons-material/Check";
import { Box, Button } from "@mui/material";
import { useTranslation } from "react-i18next";
import { ReactComponent as EditIcon } from "../../../common/icons/editDark.svg";

type Props = {
  isEditing: boolean;
  onCancel: () => void;
  saveDisabled: boolean;
  onSave: () => void;
  onEdit: () => void;
};

const TalentHrActionButtons = ({
  isEditing,
  onCancel,
  saveDisabled,
  onSave,
  onEdit,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Box display="flex" gap="1rem">
      {isEditing ? (
        <>
          <Button
            onClick={onCancel}
            sx={{ borderRadius: "15px", height: "30px" }}
            variant="outlined"
          >
            {t("common:cancelShort")}
          </Button>
          <Button
            disabled={saveDisabled}
            sx={{
              borderRadius: "15px",
              height: "30px",
            }}
            startIcon={<CheckIcon />}
            onClick={onSave}
            variant="contained"
          >
            {t("common:save")}
          </Button>
        </>
      ) : (
        <Button
          sx={{ borderRadius: "15px", height: "30px" }}
          startIcon={<EditIcon color="primary" />}
          onClick={onEdit}
          variant="outlined"
        >
          {t("common:edit")}
        </Button>
      )}
    </Box>
  );
};

export default TalentHrActionButtons;
